import { useState } from "react"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Plus } from "lucide-react"
import { AddControlPlaneResourceInstanceComposer } from "@/forms/rema/addControlPlaneResourceInstance/composer"

export interface AddResourceInstanceButtonProps {
  onSuccess?: () => void
}

export function AddResourceInstanceButton({ onSuccess }: AddResourceInstanceButtonProps) {
  const [open, setOpen] = useState(false)

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <Button size="sm" className="gap-2" onClick={() => setOpen(true)}>
        <Plus className="h-4 w-4" />
        Add Resource Instance
      </Button>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Add New Resource Instance</DialogTitle>
        </DialogHeader>
        <AddControlPlaneResourceInstanceComposer
          onSuccess={() => {
            setOpen(false)
            onSuccess?.()
          }}
          onError={(error) => alert(`Error: ${error.message}`)}
          onCancel={() => setOpen(false)}
          showHeader={false}
        />
      </DialogContent>
    </Dialog>
  )
}
